import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { admin, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (admin) navigate("/admin");
  }, [admin, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(err.response?.data?.detail || "Login failed");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center px-5">
      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="max-w-sm w-full border border-[#222] bg-[#111] p-8"
      >
        <div className="eyebrow text-[#C5B382] mb-2">Studio Login</div>
        <h1 className="font-serif text-2xl mb-8">Slavic Lashes &amp; Brows</h1>
        <label className="eyebrow text-neutral-500 block mb-2">Email</label>
        <input
          data-testid="admin-email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full bg-[#0A0A0A] border border-[#333] focus:border-[#C5B382] outline-none px-4 py-3 text-sm mb-4 transition-colors"
        />
        <label className="eyebrow text-neutral-500 block mb-2">Password</label>
        <input
          data-testid="admin-password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full bg-[#0A0A0A] border border-[#333] focus:border-[#C5B382] outline-none px-4 py-3 text-sm mb-6 transition-colors"
        />
        {error && <p data-testid="admin-login-error" className="text-red-400 text-sm mb-4">{error}</p>}
        <button
          data-testid="admin-login-submit"
          disabled={loading}
          className="w-full flex items-center justify-center gap-2 bg-[#C5B382] hover:bg-[#B8A572] text-[#0A0A0A] text-[12px] font-semibold tracking-[0.18em] uppercase py-3.5 transition-colors disabled:opacity-50"
        >
          {loading && <Loader2 size={16} className="animate-spin" />} Sign In
        </button>
      </form>
    </div>
  );
}
